/**
 * AffiliateRefStrip — Inline banner shown on the home page.
 * Renders between the game carousel and the bolão/game list.
 * Visible only when the user arrived via an affiliate ?ref= link.
 * Renders nothing when no storefront is active.
 */
import React, { useContext } from 'react';
import Contexts from '../../contexts/Contexts';
import styles from './AffiliateRefStrip.module.css';

const AffiliateRefStrip: React.FC = () => {
  const { storefront } = useContext(Contexts);
  if (!storefront) return null;

  return (
    <div
      className={styles.strip}
      style={{ borderColor: `${storefront.primary_color}44` }}
    >
      <span className={styles.icon}>🎁</span>

      <div className={styles.body}>
        <span className={styles.label}>
          Você chegou via{' '}
          <strong style={{ color: storefront.primary_color }}>
            {storefront.display_name}
          </strong>
          {storefront.tagline ? ` · ${storefront.tagline}` : ''}
        </span>
      </div>

      {storefront.logo_url && (
        <img
          src={storefront.logo_url}
          alt={storefront.display_name}
          className={styles.logo}
        />
      )}
    </div>
  );
};

export default AffiliateRefStrip;
